import { NgModule } from '@angular/core';
import {CommonModule, DatePipe, HashLocationStrategy, LocationStrategy, registerLocaleData} from '@angular/common';
import {ChucVuComponent} from '../danhmuc/chucvu/chucvu.component';
import {DoKhanComponent} from '../danhmuc/dokhan/dokhan.component';
import {DoMatComponent} from '../danhmuc/domat/domat.component';
import {DonViNgoaiComponent} from '../danhmuc/donvingoai/donvingoai.component';
import {DonViNoiBoComponent} from '../danhmuc/donvinoibo/donvinoibo.component';
import {LinhVucVanBanComponent} from '../danhmuc/linhvucvanban/linhvucvanban.component';
import {LoaiKeHoachComponent} from '../danhmuc/loaikehoach/loaikehoach.component';
import {LoaiVanBanComponent} from '../danhmuc/loaivanban/loaivanban.component';
import {NhomMauVanBanComponent} from '../danhmuc/nhommauvanban/nhommauvanban.component';
import {NhomTinTucComponent} from '../danhmuc/nhomtintuc/nhomtintuc.component';
import {ThietBiComponent} from '../danhmuc/thietbi/thietbi.component';
import {LoaiPhongComponent} from '../danhmuc/loaiphong/loaiphong.component';
import {ToaNhaComponent} from '../danhmuc/toanha/toanha.component';
import {PhongComponent} from '../danhmuc/phong/phong.component';
import {ConfirmDialogComponent} from '../dialog/confirmdialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {EgovRoutingModule} from './egov-routing.module';
import {LichDonViComponent} from '../info/lichdonvi/lichdonvi.component';
import {SoVanThuComponent} from '../info/sovanthu/sovanthu.component';
import {DonViQuanLySoComponent} from '../danhmuc/donvinoibo/donviquanlyso.component';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {TreeGridModule} from '@syncfusion/ej2-angular-treegrid';
import {TreeViewModule} from '@syncfusion/ej2-angular-navigations';
import {HoSoCaNhanComponent} from '../info/hoso/canhan/canhan.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {HoSoDonViComponent} from '../info/hoso/donvi/donvi.component';
import {UploaderModule} from '@syncfusion/ej2-angular-inputs';
import {UploadFileComponent} from '../ui/upload/uploadfile.component';
import {VanBanPhapQuyComponent} from '../info/vanbanphapquy/vanbanphapquy.component';
import {MauVanBanComponent} from '../info/mauvanban/mauvanban.component';
import {KeHoachComponent} from '../info/kehoach/kehoach.component';
import {GiaiQuyetSuVuComponent} from '../info/giaiquyetsuvu/giaiquyetsuvu.component';
import {VanBanDenComponent} from '../info/vanbanden/vanbanden.component';
import {VanBanDiComponent} from '../info/vanbandi/vanbandi.component';
import {XuLyToTrinhComponent} from '../info/giaiquyetsuvu/xulytotrinh/xulytotrinh.component';
import {ToTrinhNhanComponent} from '../info/giaiquyetsuvu/totrinhnhan/totrinhnhan.component';
import {ToTrinhDangSoanComponent} from '../info/giaiquyetsuvu/totrinhdangsoan/totrinhdangsoan.component';
import {YeuCauGuiComponent} from '../info/giaiquyetsuvu/yeucaugui/yeucaugui.component';
import {YeuCauNhanComponent} from '../info/giaiquyetsuvu/yeucaunhan/yeucaunhan.component';
import {YeuCauDangSoanComponent} from '../info/giaiquyetsuvu/yeucaudangsoan/yeucaudangsoan.component';
import {ThongBaoComponent} from '../info/thongbao/thongbao.component';
import {VanBanDenChoGiaoXLComponent} from '../info/vanbanden/chogiaoxuly/chogiaoxuly.component';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {StatusComponent} from '../ui/status/status.component';
import {VanBanDenDaVaoSoComponent} from '../info/vanbanden/davaoso/davaoso.component';
import {VanBanDenChuaXuLyComponent} from '../info/vanbanden/vanbanchuaxuly/vanbanchuaxuly.component';
import {VanBanDenDangXuLyComponent} from '../info/vanbanden/vanbandangxuly/vanbandangxuly.component';
import {VanBanDenHoanThanhComponent} from '../info/vanbanden/vanbanhoanthanh/vanbanhoanthanh.component';
import {VanBanDiChoGiaoXLComponent} from '../info/vanbandi/chogiaoxuly/chogiaoxuly.component';
import {VanBanDiDaVaoSoComponent} from '../info/vanbandi/davaoso/davaoso.component';
import {VanBanDenTongHopComponent} from '../info/vanbanden/tonghop/tonghop.component';
import {VanBanDiTongHopComponent} from '../info/vanbandi/tonghop/tonghop.component';
import {EgovMainComponent} from './main.component';
import {GiaiQuyetSuVuTongHopComponent} from '../info/giaiquyetsuvu/tonghop/tonghop.component';
import {EgovMessageComponent} from './message/message.component';
import {EgovAlertComponent} from './alert/alert.component';
import {EgovChatComponent} from './chat/chat.component';
import {EmailComponent} from '../info/email/email.component';
import {ThuDaGuiComponent} from '../info/email/thudagui/thudagui.component';
import {EmailTongHopComponent} from '../info/email/tonghop/tonghop.component';
import {ThuDaNhanComponent} from '../info/email/thudanhan/thudanhan.component';
import {ThuDaDocComponent} from '../info/email/thudadoc/thudadoc.component';
import {ThuChuaDocComponent} from '../info/email/thuchuadoc/thuchuadoc.component';
import {ThuDaXoaComponent} from '../info/email/thudaxoa/thudaxoa.component';
import {ThuDangSoanComponent} from '../info/email/thudangsoan/thudangsoan.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {SelectStaffComponent} from '../ui/selectstaff/selectstaff.component';
import {SoanToTrinhComponent} from '../info/giaiquyetsuvu/soantotrinh/soantotrinh.component';
import {EditKeHoachComponent} from '../info/kehoach/edit.component';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {UploadDropComponent} from '../ui/upload/uploaddrop.component';
import {GroupSelectComponent} from '../info/group/groupselect.component';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {DatePickerModule} from '@syncfusion/ej2-angular-calendars';
import {EditHoSoCaNhanComponent} from '../info/hoso/canhan/edit.component';
import {EditHoSoDonViComponent} from '../info/hoso/donvi/edit.component';
import {EditVBPQComponent} from '../info/vanbanphapquy/edit.component';
import {EditMauVanBanComponent} from '../info/mauvanban/edit.component';
import {SoanYeuCauComponent} from '../info/giaiquyetsuvu/soanyeucau/soanyeucau.component';
import {EditToTrinhComponent} from '../info/giaiquyetsuvu/xulytotrinh/edit.component';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthHtppInterceptorService} from '../../service/login/service-authenticate';
import {EgovLoginComponent} from './login/login.component';
import {EditYeuCauComponent} from '../info/giaiquyetsuvu/yeucaugui/edit.component';
import {SoanThongBaoComponent} from '../info/thongbao/create.component';
import {EditThongBaoComponent} from '../info/thongbao/edit.component';
import {MeetingComponent} from '../info/meeting/meeting.component';
import {EditMeetingComponent} from '../info/meeting/edit.component';
import {SoanMeetingComponent} from '../info/meeting/create.component';
import {SoanVanBanDenComponent} from '../info/vanbanden/soanvanban/create.component';
import {GroupOTherComponent} from '../info/groupother/groupother.component';
import {DropDownListModule, DropDownTreeModule, MultiSelectModule} from '@syncfusion/ej2-angular-dropdowns';
import {EditVanBanDenComponent} from '../info/vanbanden/soanvanban/edit.component';
import {GiaoViecNhanhComponent} from '../info/vanbanden/giaoviecnhanh/giaoviecnhanh.component';
import {TatCaVanBanDenComponent} from '../info/vanbanden/vanban/vanban.component';
import {PhoCapVanBanDenComponent} from '../info/vanbanden/quanlyphocap/phocap.component';
import {SoanVanBanDiComponent} from '../info/vanbandi/soanvanban/create.component';
import {SelectUnitsComponent} from '../ui/selectinner/select.component';
import {SelectUnitsOuterComponent} from '../ui/selectouter/select.component';
import {EditVanBanDiComponent} from '../info/vanbandi/soanvanban/edit.component';
import {StatusPhoCapComponent} from '../ui/status/statuspc.component';
import {GXLVanBanDiComponent} from '../info/vanbandi/giaoxuly/giaoxuly.component';
import {DocVanBanDiComponent} from '../info/vanbandi/docvanban/docvanban.component';
import {ChenHoSoVanBanDiComponent} from '../info/vanbandi/chenhoso/chenhoso.component';
import {XuLyVanBanDiComponent} from '../info/vanbandi/xulyvanban/xuly.component';
import {QLPhoCapVanBanDiComponent} from '../info/vanbandi/quanlyphocap/phocap.component';
import {ChenHoSoVanBanDenComponent} from '../info/vanbanden/chenhoso/chenhoso.component';
import {GXLVanBanDenComponent} from '../info/vanbanden/giaoxuly/giaoxuly.component';
import {CTVanbanDenComponent} from '../info/vanbanden/chuyentrinh/chuyentrinh.component';
import {CTVanbanDiComponent} from '../info/vanbandi/chuyentrinh/chuyentrinh.component';
import {ChenHoSoToTrinhComponent} from '../info/giaiquyetsuvu/chenhoso/chenhosotc.component';
import {ChenHoSoToTrinhNhanComponent} from '../info/giaiquyetsuvu/chenhoso/chenhosotcn.component';
import {ChenHoSoYeuCauNhanComponent} from '../info/giaiquyetsuvu/chenhoso/chenhosoycn.component';
import {ChenHoSoYeuCauComponent} from '../info/giaiquyetsuvu/chenhoso/chenhosoyc.component';
import {CTToTrinhComponent} from '../info/giaiquyetsuvu/chuyentrinh/chuyentrinhtc.component';
import {CTToTrinhNhanComponent} from '../info/giaiquyetsuvu/chuyentrinh/chuyentrinhtcn.component';
import {CTYeuCauNhanComponent} from '../info/giaiquyetsuvu/chuyentrinh/chuyentrinhycn.component';
import {CTYeuCauComponent} from '../info/giaiquyetsuvu/chuyentrinh/chuyentrinhyc.component';
import {SoanThuComponent} from '../info/email/soanthu/soanthu.component';
import {XuLyTongHopToTrinhComponent} from '../info/giaiquyetsuvu/xuly/xuly.component';
import {EditThuComponent} from '../info/email/soanthu/edit.component';
import {ChenHoSoThuComponent} from '../info/email/chenhoso/chenhoso.component';
import {ChenHoSoThuGuiComponent} from '../info/email/chenhoso/thugui.component';
import {CTThuNhanComponent} from '../info/email/chuyentrinh/thunhan.component';
import {CTThuGuiComponent} from '../info/email/chuyentrinh/thugui.component';
import {GVThuNhanComponent} from '../info/email/giaoviec/thunhan.component';
import {GVThuGuiComponent} from '../info/email/giaoviec/thugui.component';
import {ChartsModule} from 'ng2-charts';
import {EditLichComponent} from '../info/lichdonvi/edit.component';
import {FileLichDonViComponent} from '../info/lichdonvi/file.component';
import {FileLichCaNhanComponent} from '../info/lichcanhan/file.component';
import {EditLichCaNhanComponent} from '../info/lichcanhan/edit.component';
import {LichCaNhanComponent} from '../info/lichcanhan/lichcanhan.component';
import {XuLyTongHopYeuCauComponent} from '../info/giaiquyetsuvu/xuly/yeucau.component';
import {XuLyTongHopVanBanDenComponent} from '../info/vanbanden/xuly/xuly.component';
import {XuLyTongHopVanBanDiComponent} from '../info/vanbandi/xuly/xuly.component';
import {TraLoiThuComponent} from '../info/email/traloi/traloi.component';
import {XuLyThuComponent} from '../info/email/xuly/xuly.component';
import {GuiTiepThuComponent} from '../info/email/guitiep/guitiep.component';
import {ReadThongBaoComponent} from '../info/thongbao/read.component';
import {ThongBaoViewComponent} from '../info/thongbao/thongbaoview.component';
import {NewsComponent} from '../info/news/news.component';
import {EditNewsComponent} from '../info/news/edit.component';
import {VPPDangKyComponent} from '../info/vpp/dangky.component';
import {EditDangKyComponent} from '../info/vpp/edit.component';
import {ViewNewsComponent} from '../info/news/viewnews.component';
import {SoanTinBaiComponent} from '../info/news/create.component';
import {StatusPheDuyetComponent} from '../ui/status/statuspd.component';
import {VPPXemKQDangKyComponent} from '../info/vpp/xemkq.component';
import {VPPDuyetDangKyComponent} from '../info/vpp/duyet.component';
import {ConfirmPDDangKyComponent} from '../info/vpp/confirmpd.component';
import {DangKyPhongHopComponent} from '../info/phonghop/phonghop.component';
import {EditDangKyPhongComponent} from '../info/phonghop/edit.component';
import {XemKQDangKyPhongComponent} from '../info/phonghop/xemkq.component';
import {DuyetDangKyPhongComponent} from '../info/phonghop/duyet.component';
import {ConfirmPDDangKyPhongComponent} from '../info/phonghop/confirmpd.component';
import {LichCongTacComponent} from '../info/lichcongtac/lichcongtac.component';
import {EditLichCongTacComponent} from '../info/lichcongtac/edit.component';
import {FileLichCongTacComponent} from '../info/lichcongtac/file.component';
import {SVTVanBanDenComponent} from '../info/vanbanden/quanlyso/quanlyso.component';
import {EditSoVanThuComponent} from '../info/sovanthu/edit.component';
import {SVTVanBanDiComponent} from '../info/vanbandi/quanlyso/so.component';
import {StatusActiveComponent} from '../ui/status/active.component';
import {EditNhomVanBanDiComponent} from '../info/vanbandi/quanlyso/edit.component';
import {DSNguoiDungComponent} from '../info/users/ds.component';
import {GroupInnerComponent} from '../info/groupother/groupinner.component';
import {StaffsComponent} from '../info/users/staffs.component';
import {EditStaffsComponent} from '../info/users/edit.component';
import {SelectMultiComponent} from '../info/groupother/select.component';
import {RolesComponent} from '../info/role/role.component';
import {EditRolesComponent} from '../info/role/edit.component';
import {PermissionsComponent} from '../info/role/permission.component';
import {DSPermissionsComponent} from '../info/role/dsp.component';
import {DSStaffsPermissionsComponent} from '../info/role/st.component';
import {DSUsersComponent} from '../info/users/user.component';
import {RegUserComponent} from '../info/users/reg.component';
import {ProfileStaffsComponent} from '../info/users/profile.component';
import {EditRegUserComponent} from '../info/users/editreg.component';
import {ChangePasswordComponent} from '../info/users/password.component';
import {AuthCanActiveService} from '../../service/login/service-authentiion';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {PdfShowComponent} from '../info/view/pdf.component';
import {ChatComponent} from '../info/chat/chat.component';
import {WebSocketService} from '../../service/chat/websocket-service';

import localeVi from '@angular/common/locales/vi';
import localeEn from '@angular/common/locales/en';
import {NgMarqueeModule} from 'ng-marquee';
import {HotThongBaoComponent} from '../info/thongbao/hot.component';
import {WorkGroupComponent} from '../info/workgroup/workgroup.component';
import {WorkGroupStaffsComponent} from '../info/workgroup/workgroupstaff.component';
import {VanBanDenPhoCapComponent} from '../info/vanbanden/vanbanphocap/vanbanphocap.component';
import {GVToTrinhComponent} from '../info/giaiquyetsuvu/chuyengiaoviec/giaoviec.component';
import {ThongBaoLichComponent} from '../info/thongbao/thongbaolich.component';
import {DayWeekComponent} from '../ui/status/dayweek.component';
import {HoTroComponent} from '../info/hotro/hotro.component';
import {EditDonViNoiBoComponent} from '../danhmuc/donvinoibo/edit.component';
import {EditDonViNgoaiComponent} from '../danhmuc/donvingoai/edit.component';
import {FolderComponent} from '../info/folder/folder.component';
import {EditFolderComponent} from '../info/folder/edit.component';
import {SelectFolderComponent} from '../info/folder/select.component';
import {ChuyenDonViComponent} from '../info/users/chuyendv.component';
import {DuocXemVanBanDiComponent} from '../info/vanbandi/duocxem/duocxem.component';
import {HoSoLuuTruComponent} from '../info/hoso/luutru/luutru.component';
import {EditHoSoLuuTruComponent} from '../info/hoso/luutru/edit.component';
import {ShareHoSoComponent} from '../info/hoso/canhan/share.component';
import {DetailHoSoComponent} from '../info/hoso/canhan/detail.component';
import {SearchComponent} from '../info/search/search.component';
import {LogSearchComponent} from '../info/search/logsearch.component';
import {ConfigChatComponent} from '../info/chat/configchat.component';
import {ShareLichCaNhanComponent} from '../info/lichcanhan/share.component';
import {ShareLichDonViComponent} from '../info/lichdonvi/share.component';
import {DetailVBPQComponent} from '../info/vanbanphapquy/detail.component';
import {XuLyHoSoComponent} from '../info/hoso/xuly/hosoxuly.component';
import {DetailMeetingComponent} from '../info/meeting/detail.component';
import {UserRoleComponent} from '../info/users/userrole.component';
import {DetailThuComponent} from '../info/email/soanthu/detail.component';
import {TraLoiSoanThaoThuComponent} from '../info/email/soanthu/traloisoanthao.component';
import {UploadFileMailComponent} from '../ui/upload/uploadfilemail.component';
import {DetailKeHoachComponent} from '../info/kehoach/detail.component';
import {YKTongHopMeetingComponent} from '../info/meeting/ykientonghop.component';
import {YKienMeetingComponent} from '../info/meeting/ykien.component';
import {StatusMeetingComponent} from '../ui/status/statusmeet.component';
import {DetailDangKyComponent} from '../info/vpp/detail.component';
import {DetailDangKyPhongComponent} from '../info/phonghop/detail.component';
import {ThungRacComponent} from '../info/email/thungrac/thungrac.component';
import {ThuGuiDaXoaComponent} from '../info/email/thuguidaxoa/thuguidaxoa.component';
import {GXLCap2VanBanDenComponent} from '../info/vanbanden/giaoxuly/giaoxulycap2.component';
import {XuLyDetailVanBanDenComponent} from '../info/vanbanden/xuly/xulydetail.component';
import {YKienXuLyVanBanDenComponent} from '../info/vanbanden/xuly/ykienxuly.component';
import {ThoiHanVanBanDenComponent} from '../info/vanbanden/xuly/thoihan.component';
import {TongHopYKienVanBanDenComponent} from '../info/vanbanden/xuly/tonghop.component';
import {FileVanBanDenComponent} from '../info/vanbanden/xuly/file.component';
import {DanhSachTHVanBanDenComponent} from '../info/vanbanden/xuly/danhsach.component';
import {XuLyDetailVanBanDiComponent} from '../info/vanbandi/xuly/xulydetail.component';
import {DanhSachTHVanBanDiComponent} from '../info/vanbandi/xuly/danhsach.component';
import {FileVanBanDiComponent} from '../info/vanbandi/xuly/file.component';
import {ThoiHanVanBanDiComponent} from '../info/vanbandi/xuly/thoihan.component';
import {TongHopYKienVanBanDiComponent} from '../info/vanbandi/xuly/tonghop.component';
import {YKienXuLyVanBanDiComponent} from '../info/vanbandi/xuly/ykienxuly.component';
import {GXLCap2VanBanDiComponent} from '../info/vanbandi/giaoxuly/giaoxulycap2.component';
import {ConfigAlertComponent} from '../info/configalert/configalert.component';
import {XuLyDetailToTrinhComponent} from '../info/giaiquyetsuvu/xuly/detailtotrinh.component';
import {DanhSachTHToTrinhComponent} from '../info/giaiquyetsuvu/xuly/danhsach.component';
import {FileToTrinhComponent} from '../info/giaiquyetsuvu/xuly/file.component';
import {ThoiHanToTrinhComponent} from '../info/giaiquyetsuvu/xuly/thoihan.component';
import {TongHopYKienToTrinhComponent} from '../info/giaiquyetsuvu/xuly/tonghop.component';
import {YKienXuLyToTrinhComponent} from '../info/giaiquyetsuvu/xuly/ykienxl.component';
import {XuLyDetailYeuCauComponent} from '../info/giaiquyetsuvu/yeucau/detailyeucau.component';
import {DanhSachTHYeuCauComponent} from '../info/giaiquyetsuvu/yeucau/danhsach.component';
import {FileYeuCauComponent} from '../info/giaiquyetsuvu/yeucau/file.component';
import {ThoiHanYeuCauComponent} from '../info/giaiquyetsuvu/yeucau/thoihan.component';
import {YKienXuLyYeuCauComponent} from '../info/giaiquyetsuvu/yeucau/ykienxl.component';
import {TongHopYKienYeuCauComponent} from '../info/giaiquyetsuvu/yeucau/tonghop.component';
import {CommentLichDonViComponent} from '../info/lichdonvi/comment.component';
import {ReadLichCongTacComponent} from '../info/lichcongtac/readlichcongtac.component';
import {CommentLichCongTacComponent} from '../info/lichcongtac/comment.component';
import {LichSuLichCongTacComponent} from '../info/lichcongtac/lichsu.component';
import {TongHopLichCongTacComponent} from '../info/lichcongtac/tonghop.component';
import {LichSuLichDonViComponent} from '../info/lichdonvi/lichsu.component';
import {TongHopLichDonViComponent} from '../info/lichdonvi/tonghop.component';
import {XuLyDetailMeetingComponent} from '../info/meeting/xulydetail.component';
import {FileMeetingComponent} from '../info/meeting/file.component';
import {DanhSachTHMeetingComponent} from '../info/meeting/danhsach.component';
import {ThoiHanMeetingComponent} from '../info/meeting/thoihan.component';
import {StatusMeetingPBComponent} from '../ui/status/statuspb.component';
import {MoiHopMeetingComponent} from '../info/meeting/moihop.component';
import {JoinToTrinhComponent} from '../info/giaiquyetsuvu/xuly/join.component';
import {JoinYeuCauComponent} from '../info/giaiquyetsuvu/yeucau/join.component';
import {XuLyDetailThongBaoComponent} from '../info/thongbao/xulydetail.component';
import {YKienThongBaoComponent} from '../info/thongbao/ykien.component';
import {FileThongBaoComponent} from '../info/thongbao/file.component';
import {YKTongHopThongBaoComponent} from '../info/thongbao/tonghop.component';
import {ThemNNThongBaoComponent} from '../info/thongbao/share.component';
import {XuLyDetailHoSoComponent} from '../info/hoso/donvi/xulydetail.component';
import {YKienHoSoComponent} from '../info/hoso/donvi/ykien.component';
import {YKTongHopHoSoComponent} from '../info/hoso/donvi/tonghop.component';
import {FileHoSoComponent} from '../info/hoso/donvi/file.componen';
import {InSoCongVanDenComponent} from '../info/vanbanden/insocv/insocv.component';
import {LogEgovComponent} from '../info/log/log.component';
import {DataActionComponent} from '../ui/status/dataaction.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {OvelayComponent} from '../info/view/ovelay.component';
import {ButPheVanBanDenComponent} from '../info/vanbanden/giaoxuly/butphe.component';
import {DSButPheVanBanDenComponent} from '../info/vanbanden/butphe/danhsach.component';
import {GXLThemVanBanDenComponent} from '../info/vanbanden/giaoxuly/giaothem.component';
import {GXLThemVanBanDiComponent} from '../info/vanbandi/giaoxuly/giaothem.component';
import {FileThayVanBanDenComponent} from '../info/vanbanden/xuly/thayfile.component';
import {FileThayVanBanDiComponent} from '../info/vanbandi/xuly/thayfile.component';
import {FunctionComponent} from '../info/permission/view.component';
import {EditPermissionComponent} from '../info/permission/edit.component';
import {EditPermissionCodeComponent} from '../info/permission/editdetail.component';
import {AssignRolePermissionComponent} from '../info/permission/assign.component';
import {AssignMenuPermissionComponent} from '../info/permission/assignmenu.component';
import {StatusMenuComponent} from '../ui/status/statusmenu.component';
import {GiaiQuyetSuVuTongHopListComponent} from '../info/giaiquyetsuvu/tonghop/tonghoplist.component';
import {EgovMainListComponent} from './mainlist.component';
import {VanBanDenTongHopListComponent} from '../info/vanbanden/tonghop/tonghoplist.component';
import {VanBanDiTongHopListComponent} from '../info/vanbandi/tonghop/tonghoplist.component';
import {StatusButPheComponent} from '../ui/status/statusbp.component';
import {DestroyVanBanDenXuLyComponent} from '../info/vanbanden/giaoxuly/destroy.component';
import {DestroyVanBanDiXuLyComponent} from '../info/vanbandi/giaoxuly/destroy.component';
import {AlertThongTinComponent} from '../info/users/alert.component';
import {DocThongBaoComponent} from '../info/thongbao/docthongbao.component';
import {EscapeHtmlPipe} from '../../global/format-html';
import {ExpandTextComponent} from '../ui/command/expand-text.component';
registerLocaleData(localeVi);
@NgModule({
  declarations: [ChucVuComponent,
    DoKhanComponent,
    DoMatComponent,
    DonViNgoaiComponent,
    DonViNoiBoComponent,
    LinhVucVanBanComponent,
    LoaiKeHoachComponent,
    LoaiVanBanComponent,
    NhomMauVanBanComponent,
    NhomTinTucComponent,
    ThietBiComponent,
    LoaiPhongComponent,
    ToaNhaComponent,
    PhongComponent,
    ConfirmDialogComponent,
    LichDonViComponent,
    SoVanThuComponent,
    DonViQuanLySoComponent,
    HoSoCaNhanComponent,
    HoSoDonViComponent,
    UploadFileComponent,
    VanBanPhapQuyComponent,
    MauVanBanComponent,
    KeHoachComponent,
    GiaiQuyetSuVuComponent,
    VanBanDenComponent,
    VanBanDiComponent,
    XuLyToTrinhComponent,
    ToTrinhNhanComponent,
    ToTrinhDangSoanComponent,
    YeuCauGuiComponent,
    YeuCauNhanComponent,
    YeuCauDangSoanComponent,
    ThongBaoComponent,
    VanBanDenChoGiaoXLComponent,
    StatusComponent,
    StatusPheDuyetComponent,
    VanBanDenDaVaoSoComponent,
    VanBanDenChuaXuLyComponent,
    VanBanDenDangXuLyComponent,
    VanBanDenHoanThanhComponent,
    VanBanDiChoGiaoXLComponent,
    VanBanDiDaVaoSoComponent,
    EgovMainComponent,
    VanBanDenTongHopComponent,
    VanBanDiTongHopComponent,
    GiaiQuyetSuVuTongHopComponent,
    EgovMessageComponent,
    EgovAlertComponent,
    EgovChatComponent,
    EmailComponent,
    ThuDaGuiComponent,
    EmailTongHopComponent,
    ThuDaNhanComponent,
    ThuDaDocComponent,
    ThuChuaDocComponent,
    ThuDaXoaComponent,
    ThuDangSoanComponent,
    SelectStaffComponent,
    SoanToTrinhComponent,
    EditKeHoachComponent,
    UploadDropComponent,
    GroupSelectComponent,
    EditHoSoCaNhanComponent,
    EditHoSoDonViComponent,
    EditVBPQComponent,
    EditMauVanBanComponent,
    SoanYeuCauComponent,
    EditToTrinhComponent,
    EgovLoginComponent,
    EditYeuCauComponent,
    EditThongBaoComponent,
    SoanThongBaoComponent,
    MeetingComponent,
    EditMeetingComponent,
    SoanMeetingComponent,
    SoanVanBanDenComponent,
    GroupOTherComponent,
    EditVanBanDenComponent,
    GiaoViecNhanhComponent,
    TatCaVanBanDenComponent,
    PhoCapVanBanDenComponent,
    SoanVanBanDiComponent,
    SelectUnitsComponent,
    SelectUnitsOuterComponent,
    EditVanBanDiComponent,
    StatusPhoCapComponent,
    GXLVanBanDiComponent,
    DocVanBanDiComponent,
    ChenHoSoVanBanDiComponent,
    XuLyVanBanDiComponent,
    QLPhoCapVanBanDiComponent,
    ChenHoSoVanBanDenComponent,
    GXLVanBanDenComponent,
    CTVanbanDenComponent,
    CTVanbanDiComponent,
    ChenHoSoToTrinhComponent,
    ChenHoSoToTrinhNhanComponent,
    ChenHoSoYeuCauComponent,
    ChenHoSoYeuCauNhanComponent,
    CTToTrinhComponent,
    CTToTrinhNhanComponent,
    CTYeuCauComponent,
    CTYeuCauNhanComponent,
    SoanThuComponent,
    XuLyTongHopToTrinhComponent,
    EditThuComponent,
    ChenHoSoThuComponent,
    ChenHoSoThuGuiComponent,
    CTThuNhanComponent,
    CTThuGuiComponent,
    GVThuNhanComponent,
    GVThuGuiComponent,
    EditLichComponent,
    FileLichDonViComponent,
    FileLichCaNhanComponent,
    EditLichCaNhanComponent,
    FileLichCaNhanComponent,
    EditLichCaNhanComponent,
    LichCaNhanComponent,
    XuLyTongHopYeuCauComponent,
    XuLyTongHopVanBanDenComponent,
    XuLyTongHopVanBanDiComponent,
    TraLoiThuComponent,
    XuLyThuComponent,
    GuiTiepThuComponent,
    ReadThongBaoComponent,
    ThongBaoViewComponent,
    NewsComponent,
    EditNewsComponent,
    VPPDangKyComponent,
    EditDangKyComponent,
    ViewNewsComponent,
    SoanTinBaiComponent,
    VPPXemKQDangKyComponent,
    VPPDuyetDangKyComponent,
    ConfirmPDDangKyComponent,
    DangKyPhongHopComponent,
    EditDangKyPhongComponent,
    XemKQDangKyPhongComponent,
    DuyetDangKyPhongComponent,
    ConfirmPDDangKyPhongComponent,
    LichCongTacComponent,
    EditLichCongTacComponent,
    FileLichCongTacComponent,
    SVTVanBanDenComponent,
    EditSoVanThuComponent,
    SVTVanBanDiComponent,
    StatusActiveComponent,
    EditNhomVanBanDiComponent,
    DSNguoiDungComponent,
    GroupInnerComponent,
    StaffsComponent,
    EditStaffsComponent,
    SelectMultiComponent,
    RolesComponent,
    EditRolesComponent,
    PermissionsComponent,
    DSPermissionsComponent,
    DSStaffsPermissionsComponent,
    DSUsersComponent,
    RegUserComponent,
    ProfileStaffsComponent,
    EditRegUserComponent,
    ChangePasswordComponent,
    PdfShowComponent,
    ChatComponent,
    HotThongBaoComponent,
    WorkGroupComponent,
    WorkGroupStaffsComponent,
    VanBanDenPhoCapComponent,
    GVToTrinhComponent,
    ThongBaoLichComponent,
    DayWeekComponent,
    HoTroComponent,
    EditDonViNoiBoComponent,
    EditDonViNgoaiComponent,
    FolderComponent,
    EditFolderComponent,
    SelectFolderComponent,
    ChuyenDonViComponent,
    DuocXemVanBanDiComponent,
    HoSoLuuTruComponent,
    EditHoSoLuuTruComponent,
    ShareHoSoComponent,
    DetailHoSoComponent,
    SearchComponent,
    LogSearchComponent,
    ConfigChatComponent,
    ShareLichCaNhanComponent,
    ShareLichDonViComponent,
    DetailVBPQComponent,
    XuLyHoSoComponent,
    DetailMeetingComponent,
    UserRoleComponent,
    DetailThuComponent,
    TraLoiSoanThaoThuComponent,
    UploadFileMailComponent,
    DetailKeHoachComponent,
    YKTongHopMeetingComponent,
    YKienMeetingComponent,
    StatusMeetingComponent,
    DetailDangKyPhongComponent,
    DetailDangKyComponent,
    ThungRacComponent,
    ThuGuiDaXoaComponent,
    GXLCap2VanBanDenComponent,
    XuLyDetailVanBanDenComponent,
    YKienXuLyVanBanDenComponent,
    ThoiHanVanBanDenComponent,
    TongHopYKienVanBanDenComponent,
    FileVanBanDenComponent,
    DanhSachTHVanBanDenComponent,
    XuLyDetailVanBanDiComponent,
    DanhSachTHVanBanDiComponent,
    FileVanBanDiComponent,
    ThoiHanVanBanDiComponent,
    TongHopYKienVanBanDiComponent,
    YKienXuLyVanBanDiComponent,
    GXLCap2VanBanDiComponent,
    ConfigAlertComponent,
    XuLyDetailToTrinhComponent,
    DanhSachTHToTrinhComponent,
    FileToTrinhComponent,
    ThoiHanToTrinhComponent,
    TongHopYKienToTrinhComponent,
    YKienXuLyToTrinhComponent,
    XuLyDetailYeuCauComponent,
    DanhSachTHYeuCauComponent,
    FileYeuCauComponent,
    ThoiHanYeuCauComponent,
    YKienXuLyYeuCauComponent,
    TongHopYKienYeuCauComponent,
    CommentLichCongTacComponent,
    CommentLichDonViComponent,
    ReadLichCongTacComponent,
    LichSuLichCongTacComponent,
    TongHopLichCongTacComponent,
    LichSuLichDonViComponent,
    TongHopLichDonViComponent,
    XuLyDetailMeetingComponent,
    FileMeetingComponent,
    DanhSachTHMeetingComponent,
    ThoiHanMeetingComponent,
    StatusMeetingPBComponent,
    MoiHopMeetingComponent,
    JoinToTrinhComponent,
    JoinYeuCauComponent,
    XuLyDetailThongBaoComponent,
    YKienThongBaoComponent,
    FileThongBaoComponent,
    YKTongHopThongBaoComponent,
    ThemNNThongBaoComponent,
    XuLyDetailHoSoComponent,
    YKienHoSoComponent,
    YKTongHopHoSoComponent,
    FileHoSoComponent,
    InSoCongVanDenComponent,
    LogEgovComponent,
    DataActionComponent,
    OvelayComponent,
    ButPheVanBanDenComponent,
    DSButPheVanBanDenComponent,
    GXLThemVanBanDenComponent,
    GXLThemVanBanDiComponent,
    FileThayVanBanDenComponent,
    FileThayVanBanDiComponent,
    FunctionComponent,
    EditPermissionComponent,
    EditPermissionCodeComponent,
    AssignRolePermissionComponent,
    AssignMenuPermissionComponent,
    StatusMenuComponent,
    GiaiQuyetSuVuTongHopListComponent,
    EgovMainListComponent,
    VanBanDenTongHopListComponent,
    VanBanDiTongHopListComponent,
    StatusButPheComponent,
    DestroyVanBanDenXuLyComponent,
    DestroyVanBanDiXuLyComponent,
    AlertThongTinComponent,
    DocThongBaoComponent,
    EscapeHtmlPipe,
    ExpandTextComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        EgovRoutingModule,
        ReactiveFormsModule,
        CollapseModule.forRoot(),
        ChartsModule,
        PaginationModule.forRoot(),
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        TreeGridModule,
        TreeViewModule,
        CKEditorModule,
        UploaderModule,
        NgSelectModule,
        TabsModule.forRoot(),
        BsDatepickerModule.forRoot(),
        DatePickerModule,
        DropDownTreeModule,
        DropDownListModule,
        MultiSelectModule,
        PdfViewerModule,
        NgMarqueeModule

    ],
  providers: [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHtppInterceptorService, multi: true
  }
  , BsModalService, DatePipe, WebSocketService
],
  exports: [
    EgovMessageComponent,
    EgovAlertComponent,
    EgovChatComponent,
    ChatComponent,
    HotThongBaoComponent,
    ThongBaoLichComponent,
    OvelayComponent
  ],
  entryComponents: [
    ConfirmDialogComponent,
    UploadFileComponent,
    XuLyToTrinhComponent,
    ToTrinhNhanComponent,
    ToTrinhDangSoanComponent,
    YeuCauGuiComponent,
    YeuCauNhanComponent,
    YeuCauDangSoanComponent,
    ThongBaoComponent,
    VanBanDenChoGiaoXLComponent,
    StatusComponent,
    StatusPheDuyetComponent,
    VanBanDenDaVaoSoComponent,
    VanBanDenChuaXuLyComponent,
    VanBanDenDangXuLyComponent,
    VanBanDenHoanThanhComponent,
    VanBanDiChoGiaoXLComponent,
    VanBanDiDaVaoSoComponent,
    VanBanDenTongHopComponent,
    VanBanDiTongHopComponent,
    GiaiQuyetSuVuTongHopComponent,
    EgovMessageComponent,
    EgovAlertComponent,
    EgovChatComponent,
    ThuDaGuiComponent,
    EmailTongHopComponent,
    ThuDaNhanComponent,
    ThuDaDocComponent,
    ThuChuaDocComponent,
    ThuDaXoaComponent,
    ThuDangSoanComponent,
    SelectStaffComponent,
    SoanToTrinhComponent,
    EditKeHoachComponent,
    UploadDropComponent,
    GroupSelectComponent,
    EditHoSoCaNhanComponent,
    EditHoSoDonViComponent,
    EditVBPQComponent,
    EditMauVanBanComponent,
    SoanYeuCauComponent,
    EditToTrinhComponent,
    EditYeuCauComponent,
    EditThongBaoComponent,
    SoanThongBaoComponent,
    MeetingComponent,
    EditMeetingComponent,
    SoanMeetingComponent,
    SoanVanBanDenComponent,
    GroupOTherComponent,
    EditVanBanDenComponent,
    GiaoViecNhanhComponent,
    TatCaVanBanDenComponent,
    PhoCapVanBanDenComponent,
    SoanVanBanDiComponent,
    SelectUnitsComponent,
    SelectUnitsOuterComponent,
    EditVanBanDiComponent,
    StatusPhoCapComponent,
    GXLVanBanDiComponent,
    DocVanBanDiComponent,
    ChenHoSoVanBanDiComponent,
    XuLyVanBanDiComponent,
    QLPhoCapVanBanDiComponent,
    ChenHoSoVanBanDenComponent,
    GXLVanBanDenComponent,
    CTVanbanDenComponent,
    CTVanbanDiComponent,
    ChenHoSoToTrinhComponent,
    ChenHoSoToTrinhNhanComponent,
    ChenHoSoYeuCauComponent,
    ChenHoSoYeuCauNhanComponent,
    CTToTrinhComponent,
    CTToTrinhNhanComponent,
    CTYeuCauComponent,
    CTYeuCauNhanComponent,
    SoanThuComponent,
    XuLyTongHopToTrinhComponent,
    EditThuComponent,
    ChenHoSoThuComponent,
    ChenHoSoThuGuiComponent,
    CTThuNhanComponent,
    CTThuGuiComponent,
    GVThuNhanComponent,
    GVThuGuiComponent,
    EditLichComponent,
    FileLichDonViComponent,
    EditLichCaNhanComponent,
    FileLichCaNhanComponent,
    XuLyTongHopYeuCauComponent,
    XuLyTongHopVanBanDenComponent,
    XuLyTongHopVanBanDiComponent,
    TraLoiThuComponent,
    XuLyThuComponent,
    GuiTiepThuComponent,
    ReadThongBaoComponent,
    ThongBaoViewComponent,
    NewsComponent,
    EditNewsComponent,
    VPPDangKyComponent,
    EditDangKyComponent,
    SoanTinBaiComponent,
    ConfirmPDDangKyComponent,
    EditDangKyPhongComponent,
    ConfirmPDDangKyPhongComponent,
    EditLichCongTacComponent,
    FileLichCongTacComponent,
    SVTVanBanDenComponent,
    EditSoVanThuComponent,
    SVTVanBanDiComponent,
    StatusActiveComponent,
    EditNhomVanBanDiComponent,
    DSNguoiDungComponent,
    GroupInnerComponent,
    EditStaffsComponent,
    SelectMultiComponent,
    EditRolesComponent,
    PermissionsComponent,
    DSPermissionsComponent,
    DSStaffsPermissionsComponent,
    RegUserComponent,
    ProfileStaffsComponent,
    EditRegUserComponent,
    ChangePasswordComponent,
    PdfShowComponent,
    ChatComponent,
    WorkGroupStaffsComponent,
    GVToTrinhComponent,
    DayWeekComponent,
    EditDonViNoiBoComponent,
    EditDonViNgoaiComponent,
    EditFolderComponent,
    SelectFolderComponent,
    ChuyenDonViComponent,
    DuocXemVanBanDiComponent,
    EditHoSoLuuTruComponent,
    ShareHoSoComponent,
    DetailHoSoComponent,
    LogSearchComponent,
    ConfigChatComponent,
    ShareLichCaNhanComponent,
    ShareLichDonViComponent,
    DetailVBPQComponent,
    XuLyHoSoComponent,
    DetailMeetingComponent,
    UserRoleComponent,
    DetailThuComponent,
    TraLoiSoanThaoThuComponent,
    UploadFileMailComponent,
    DetailKeHoachComponent,
    YKTongHopMeetingComponent,
    YKienMeetingComponent,
    StatusMeetingComponent,
    DetailDangKyPhongComponent,
    DetailDangKyComponent,
    ThungRacComponent,
    ThuGuiDaXoaComponent,
    GXLCap2VanBanDenComponent,
    XuLyDetailVanBanDenComponent,
    YKienXuLyVanBanDenComponent,
    ThoiHanVanBanDenComponent,
    TongHopYKienVanBanDenComponent,
    FileVanBanDenComponent,
    DanhSachTHVanBanDenComponent,
    XuLyDetailVanBanDiComponent,
    DanhSachTHVanBanDiComponent,
    FileVanBanDiComponent,
    ThoiHanVanBanDiComponent,
    TongHopYKienVanBanDiComponent,
    YKienXuLyVanBanDiComponent,
    GXLCap2VanBanDiComponent,
    ConfigAlertComponent,
    XuLyDetailToTrinhComponent,
    DanhSachTHToTrinhComponent,
    FileToTrinhComponent,
    ThoiHanToTrinhComponent,
    TongHopYKienToTrinhComponent,
    YKienXuLyToTrinhComponent,
    XuLyDetailYeuCauComponent,
    DanhSachTHYeuCauComponent,
    FileYeuCauComponent,
    ThoiHanYeuCauComponent,
    YKienXuLyYeuCauComponent,
    TongHopYKienYeuCauComponent,
    CommentLichCongTacComponent,
    CommentLichDonViComponent,
    ReadLichCongTacComponent,
    LichSuLichCongTacComponent,
    TongHopLichCongTacComponent,
    LichSuLichDonViComponent,
    TongHopLichDonViComponent,
    XuLyDetailMeetingComponent,
    FileMeetingComponent,
    DanhSachTHMeetingComponent,
    ThoiHanMeetingComponent,
    StatusMeetingPBComponent,
    MoiHopMeetingComponent,
    JoinToTrinhComponent,
    JoinYeuCauComponent,
    XuLyDetailThongBaoComponent,
    YKienThongBaoComponent,
    FileThongBaoComponent,
    YKTongHopThongBaoComponent,
    ThemNNThongBaoComponent,
    XuLyDetailHoSoComponent,
    YKienHoSoComponent,
    YKTongHopHoSoComponent,
    FileHoSoComponent,
    InSoCongVanDenComponent,
    DataActionComponent,
    OvelayComponent,
    ButPheVanBanDenComponent,
    DSButPheVanBanDenComponent,
    GXLThemVanBanDenComponent,
    GXLThemVanBanDiComponent,
    FileThayVanBanDenComponent,
    FileThayVanBanDiComponent,
    EditPermissionComponent,
    EditPermissionCodeComponent,
    AssignRolePermissionComponent,
    AssignMenuPermissionComponent,
    StatusMenuComponent,
    StatusButPheComponent,
    DestroyVanBanDenXuLyComponent,
    DestroyVanBanDiXuLyComponent,
    AlertThongTinComponent,
    ExpandTextComponent
  ]
})
export class EgovModule {

}
